import { Link } from "react-router-dom";
import { EyeIcon } from "../../../components/Icons";

export const credencialesNotificadoresTableData = (data, getCredencialNotificador) => {
  const columns = [
    { field: "id", headerName: "ID", hide: false },
    {
      field: "razon_social",
      headerName: "Nombre",
      flex: 2,
      sortable: true,
    },
    {
      field: "documento",
      headerName: "Documento",
      flex: 1,
      sortable: true,
    },
    {
      field: "actions",
      headerName: "Acciones",
      minWidth: 200,
      flex: 2,
      renderCell: (params) => {
        return (
          <>
            <div className="">
              <Link
                onClick={() => {
                  getCredencialNotificador(params.row.id);
                }}
                style={{ textDecoration: "none" }}
              >
                <EyeIcon /> Ver
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  const rows = data.map((d) => {
    return {
      id: d.id,
      razon_social: d.razon_social,
      documento: d?.documento,
      genero: d?.genero,
      qr_path: d?.qr_path,
      qr_token: d?.qr_token,
      updated_at: d.updated_at,
      deleted_at: d.deleted_at,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.razon_social)?.toString().toLowerCase().includes(value) ||
      String(d.documento)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
